import { PageContextProps } from 'application/contexts/PageContext';
import { queryCmsContent } from './_api';
import { queryCDA } from './queryCDA';

export interface CDADictionaryItem {
	properties: {
		groupKeyReference: {
			properties: {
				groupKey: string;
			};
		}[];
		itemKey: string;
		value: string;
	};
}

export interface CDADictionary {
	total: number;
	items: CDADictionaryItem[];
}

export const getDictionaryFromCms = async (pageContext: Partial<PageContextProps>): Promise<Content.DictionaryItem[]> => {
	const query = `{
		dictionary {
			key
			values {
				culture
				value
			}
		}
	}`;

	const dictionary: { dictionary: Content.DictionaryItem[] } = await queryCmsContent({
		query,
		pageContext,
		requestType: 'dictionary',
	});

	return dictionary?.dictionary;
};

export const getDictionaryFromCDA = async (pageContext: Partial<PageContextProps>): Promise<Models.Dictionary> => {
	const dictionary: CDADictionary = await queryCDA({
		pageContext,
		url: 'umbraco/delivery/api/v2/content',
		urlParams: {
			filter: 'contentType:dictionaryItem',
			fields: 'properties[groupKeyReference,itemKey,value]',
			expand: 'properties[groupKeyReference]',
			take: '200',
		},
		requestType: 'dictionary',
		globalApiEnabled: false,
	});

	const dictionaryModel = {
		items: dictionary?.items.map((item) => {
			const { groupKeyReference, itemKey } = item?.properties ?? {};
			let { value } = item?.properties ?? {};
			if (groupKeyReference !== null && groupKeyReference.length > 0) {
				if (value === '*NOT TRANSLATED*') value = '';
				return {
					key: `${groupKeyReference[0].properties.groupKey}.${itemKey}`,
					value,
				};
			} else {
				console.log('-- ERROR: getDictionaryFromCDA', groupKeyReference);
			}
		}),
	};

	return dictionaryModel;
};
